/**
 * Map items with capped concurrency (skills/performance: file uploads 3–5).
 * @template T, R
 * @param {T[]} items
 * @param {number} concurrency
 * @param {(item: T, index: number) => Promise<R>} mapper
 * @returns {Promise<R[]>}
 */
export async function mapWithConcurrency (items, concurrency, mapper) {
  const list = Array.isArray(items) ? items : []
  if (list.length === 0) return []

  const limit = Math.max(1, Number(concurrency) || 1)
  const results = new Array(list.length)
  let nextIndex = 0

  async function worker () {
    while (nextIndex < list.length) {
      const index = nextIndex
      nextIndex += 1
      results[index] = await mapper(list[index], index)
    }
  }

  const workers = Array.from({ length: Math.min(limit, list.length) }, () => worker())
  await Promise.all(workers)
  return results
}

export const FILE_UPLOAD_CONCURRENCY = 4

export default mapWithConcurrency
